<ion-card>

  <div>
    <ion-label *ngIf="statusMultiluck"><b>Parabéns!</b> <br> Você <b>GANHOU</b> um</ion-label>
    <ion-label *ngIf="!statusMultiluck">Não foi desta vez, <b> tente novamente! </b></ion-label>
    <ion-label *ngIf="bonusConsolacao === true && slotPremiado === false">{{ message }}</ion-label>
    <ion-img [src]="imageRender()"></ion-img>
    <span *ngIf="productName"><strong>{{productName}}</strong></span>
  </div>

  <ion-button (click)="touchDismiss()">{{!statusMultiluck ? 'OK' : 'RESGATAR PRÊMIO'}}</ion-button>
  <ion-button *ngIf="!statusMultiluck" (click)="playAgain()">JOGAR NOVAMENTE</ion-button>

</ion-card>
